// extracted by mini-css-extract-plugin
var _1 = "EmailAttachedTagDate-moduledate__rbFam";
export { _1 as "date" }
